import { CampaignAdProductsCountryConfig } from '@features/campaigns/shared/config/adProductsCountryConfig.ts';

export interface DisplayCreativesImages {
  lShapeImageUrl?: string | File[] | null;
  landingImageUrl?: string | File[] | null;
  switchInLeftImageUrl?: string | File[] | null;
  switchInBottomImageUrl?: string | File[] | null;
}

export interface ForcedVisibleFormElementsByType {
  formatTypeVideo: boolean;
  formatTypeDisplay: boolean;
}

export function countUploadedDisplayCreatives(images: DisplayCreativesImages): number {
  return Object.values(images).filter(Boolean).length;
}

export function areDisplayCreativesComplete(
  config: CampaignAdProductsCountryConfig,
  images: DisplayCreativesImages,
): boolean {
  return countUploadedDisplayCreatives(images) >= config.requiredDisplayCreativesCount;
}

export function getForcedVisibleFormElementsByType(
  config: CampaignAdProductsCountryConfig,
): ForcedVisibleFormElementsByType | null {
  if (!config.forcedFormatTypes) {
    return null;
  }

  return {
    formatTypeDisplay: config.forcedFormatTypes.display,
    formatTypeVideo: config.forcedFormatTypes.video,
  };
}
